// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3B6Jb","title":"Info_title__pwjgK","selects":"Info_selects__30tHa","requiredAsterisk":"Info_requiredAsterisk__1kaj5"};